// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import addReorderPadFilters from "@keller/App/Handlers/ReorderPad/AddReorderPadFilters";
import { CustomAppState } from "@keller/App/Store/Reducers";
import { getReorderPadDataViewProperty } from "@keller/App/Store/Selectors/ReorderPadSelectors";
import { color, xScreen } from "@keller/XDL/Utilities";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => ({
    pagination: getReorderPadDataViewProperty(state, "pagination"),
    isTabletScreen: state.xCommon.isTabletScreen,
});

const mapDispatchToProps = {
    addReorderPadFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductListSortSelectStyles {
    select?: SelectPresentationProps;
}

export const sortSelectStyles: ProductListSortSelectStyles = {
    select: {
        labelProps: {
            size: 15,
            weight: "normal",
            css: css`
                width: unset;
                ${xScreen("lte", "md")} {
                    font-weight: bold;
                    width: 120px;
                    text-align: left;
                }
            `,
        },
        cssOverrides: {
            formField: css`
                width: 280px;
                ${xScreen("lte", "md")} {
                    align-items: flex-start;
                    width: 100%;
                    flex: 1;
                }
            `,
            formInputWrapper: css`
                flex-grow: 1;
            `,
        },
    },
};

const styles = sortSelectStyles;

const ReorderPadSortSelect = ({ addReorderPadFilters, pagination, isTabletScreen }: Props) => {
    if (!pagination) {
        return null;
    }

    const onChangeSortHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        addReorderPadFilters({ sort: event.currentTarget.value });
    };

    return (
        <Select
            {...styles.select}
            label={translate("Sort by")}
            value={pagination.sortType}
            labelPosition={isTabletScreen ? "top" : "left"}
            onChange={onChangeSortHandler}
            data-test-selector="productListSortSelect"
        >
            {pagination.sortOptions.map(sortOption => (
                <option key={sortOption.sortType} value={sortOption.sortType}>
                    {sortOption.displayName}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReorderPadSortSelect);
